import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const TradingAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.trading} />

export default TradingAppDevelopment
